import { ChangeDetectionStrategy, Component, computed, input, output } from "@angular/core";
import { MatButton, MatIconButton } from "@angular/material/button";
import { MatIcon } from "@angular/material/icon";
import { MatMenu, MatMenuItem, MatMenuTrigger } from "@angular/material/menu";
import type { ActionId, Capability } from "../../../../model/action.types";

/**
 * Renders a primary action button and an overflow (⋯) menu for the remaining capabilities.
 * Debug-only capabilities are shown in the menu only when debugMode is true.
 */
@Component({
  selector: "app-content-action-bar",
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatButton, MatIconButton, MatIcon, MatMenu, MatMenuItem, MatMenuTrigger],
  templateUrl: "./content-action-bar.component.html",
  styleUrl: "./content-action-bar.component.scss",
})
export class ContentActionBarComponent {
  /** All capabilities for this data type (including debugOnly). */
  capabilities = input.required<Capability[]>();

  /** When true, debugOnly capabilities are visible in the overflow menu. */
  debugMode = input(false);

  /** Emitted when the user triggers any action. */
  readonly actionTriggered = output<ActionId>();

  protected readonly primaryCapability = computed(() => this.capabilities().find((c) => c.primary));

  protected readonly menuCapabilities = computed(() => {
    const dm = this.debugMode();
    return this.capabilities()
      .filter((c) => !c.primary)
      .filter((c) => !c.debugOnly || dm);
  });

  protected trigger(action: ActionId): void {
    this.actionTriggered.emit(action);
  }
}
